import { c as _c } from "react/compiler-runtime";
import CallSplit from "@mui/icons-material/CallSplit";
import History from "@mui/icons-material/History";
import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline";
import { alpha, Box, Chip, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { HomeLandingHeroPreviewRuntime } from "#/features/homePage/ui/landing/HomeLandingHeroPreviewRuntime";
import type { TranslationFunctions } from "#/i18n/i18n-types";
type HomeLandingHeroPreviewProps = {
  LL: TranslationFunctions;
};
const codeSnippet = `function invertTree(root) {
  if (!root) return null;

  const left = invertTree(root.left);
  const right = invertTree(root.right);

  root.left = right;
  root.right = left;
  return root;
}`;
const WINDOW_CONTROLS = ["#ff5f57", "#febc2e", "#28c840"] as const;
export const HomeLandingHeroPreview: React.FC<HomeLandingHeroPreviewProps> = t0 => {
  const $ = _c(91);
  const {
    LL
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "auto",
      sm: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== theme.appDesign.outline) {
    t2 = alpha(theme.appDesign.outline, 0.18);
    $[1] = theme.appDesign.outline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `1px solid ${t2}`;
  let t4;
  if ($[3] !== theme.appDesign.surface) {
    t4 = alpha(theme.appDesign.surface, 0.86);
    $[3] = theme.appDesign.surface;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== theme.appDesign.background) {
    t5 = alpha(theme.appDesign.background, 0.46);
    $[5] = theme.appDesign.background;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `0 24px 60px ${t5}`;
  let t7;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t6) {
    t7 = {
      position: "relative",
      width: "100%",
      minWidth: 0,
      mx: t1,
      borderRadius: 4,
      border: t3,
      bgcolor: t4,
      backdropFilter: "blur(18px)",
      boxShadow: t6,
      overflow: "hidden"
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      xs: "column",
      sm: "row"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      xs: "stretch",
      sm: "center"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== theme.appDesign.outline) {
    t10 = alpha(theme.appDesign.outline, 0.14);
    $[13] = theme.appDesign.outline;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = `1px solid ${t10}`;
  let t12;
  if ($[15] !== t11) {
    t12 = {
      p: 1.5,
      borderBottom: t11,
      columnGap: 1.5,
      rowGap: 1.25
    };
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      xs: "center",
      sm: "flex-start"
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== theme.appDesign.background) {
    t14 = WINDOW_CONTROLS.map(color => <Box key={color} sx={{
      width: 11,
      height: 11,
      borderRadius: "50%",
      bgcolor: color,
      boxShadow: `0 0 0 1px ${alpha(theme.appDesign.background, 0.35)} inset`
    }} />);
    $[18] = theme.appDesign.background;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = <Stack direction="row" spacing={1} alignItems="center" justifyContent={t13}>{t14}</Stack>;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      flexWrap: "wrap",
      rowGap: 1
    };
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <PlayCircleOutline fontSize="small" />;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== LL) {
    t18 = LL.HOME_HOW_STEP_2_TITLE();
    $[24] = LL;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t18) {
    t19 = <Chip size="small" icon={t17} label={t18} />;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <History fontSize="small" />;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== LL) {
    t21 = LL.REPLAY();
    $[29] = LL;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== t21) {
    t22 = <Chip size="small" icon={t20} label={t21} />;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <CallSplit fontSize="small" />;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== LL) {
    t24 = LL.CALLSTACK();
    $[34] = LL;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== t24) {
    t25 = <Chip size="small" icon={t23} label={t24} />;
    $[36] = t24;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== t19 || $[39] !== t22 || $[40] !== t25) {
    t26 = <Stack direction="row" spacing={1} justifyContent="flex-end" sx={t16}>{t19}{t22}{t25}</Stack>;
    $[38] = t19;
    $[39] = t22;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t12 || $[43] !== t15 || $[44] !== t26) {
    t27 = <Stack direction={t8} spacing={1.25} justifyContent="space-between" alignItems={t9} sx={t12}>{t15}{t26}</Stack>;
    $[42] = t12;
    $[43] = t15;
    $[44] = t26;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        md: "1.05fr 0.95fr"
      },
      minWidth: 0
    };
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  let t30;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      xs: "none",
      md: "block"
    };
    t30 = {
      xs: 1.5,
      sm: 2.5
    };
    $[47] = t29;
    $[48] = t30;
  } else {
    t29 = $[47];
    t30 = $[48];
  }
  let t31;
  if ($[49] !== theme.appDesign.outline) {
    t31 = alpha(theme.appDesign.outline, 0.14);
    $[49] = theme.appDesign.outline;
    $[50] = t31;
  } else {
    t31 = $[50];
  }
  const t32 = `1px solid ${t31}`;
  let t33;
  if ($[51] !== t32) {
    t33 = {
      xs: "none",
      md: t32
    };
    $[51] = t32;
    $[52] = t33;
  } else {
    t33 = $[52];
  }
  let t34;
  if ($[53] !== theme.appDesign.outline) {
    t34 = alpha(theme.appDesign.outline, 0.14);
    $[53] = theme.appDesign.outline;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  const t35 = `1px solid ${t34}`;
  let t36;
  if ($[55] !== t35) {
    t36 = {
      xs: t35,
      md: "none"
    };
    $[55] = t35;
    $[56] = t36;
  } else {
    t36 = $[56];
  }
  let t37;
  if ($[57] !== t33 || $[58] !== t36) {
    t37 = {
      display: t29,
      p: t30,
      minWidth: 0,
      borderRight: t33,
      borderBottom: t36
    };
    $[57] = t33;
    $[58] = t36;
    $[59] = t37;
  } else {
    t37 = $[59];
  }
  let t38;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      minWidth: 0
    };
    $[60] = t38;
  } else {
    t38 = $[60];
  }
  let t39;
  if ($[61] !== LL) {
    t39 = LL.HOME_LANDING_PREVIEW_CODE_LANGUAGE();
    $[61] = LL;
    $[62] = t39;
  } else {
    t39 = $[62];
  }
  let t40;
  if ($[63] !== t39) {
    t40 = <Typography variant="subtitle2" color="text.secondary">{t39}</Typography>;
    $[63] = t39;
    $[64] = t40;
  } else {
    t40 = $[64];
  }
  let t41;
  if ($[65] !== LL) {
    t41 = LL.HOME_LANDING_PREVIEW_CODE_FILENAME();
    $[65] = LL;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] !== t41) {
    t42 = <Typography variant="caption" color="text.secondary">{t41}</Typography>;
    $[67] = t41;
    $[68] = t42;
  } else {
    t42 = $[68];
  }
  let t43;
  if ($[69] !== t40 || $[70] !== t42) {
    t43 = <Stack direction="row" justifyContent="space-between" alignItems="center" sx={t38}>{t40}{t42}</Stack>;
    $[69] = t40;
    $[70] = t42;
    $[71] = t43;
  } else {
    t43 = $[71];
  }
  let t44;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = {
      xs: "0.76rem",
      sm: "0.86rem"
    };
    $[72] = t44;
  } else {
    t44 = $[72];
  }
  let t45;
  if ($[73] !== theme.appDesign.accentSoft) {
    t45 = <Box component="pre" sx={{
      m: 0,
      p: 0,
      overflowX: "auto",
      fontFamily: "\"IBM Plex Mono\", \"SFMono-Regular\", Consolas, \"Liberation Mono\", monospace",
      fontSize: t44,
      lineHeight: 1.7,
      color: theme.appDesign.accentSoft,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word"
    }}>{codeSnippet}</Box>;
    $[73] = theme.appDesign.accentSoft;
    $[74] = t45;
  } else {
    t45 = $[74];
  }
  let t46;
  if ($[75] !== t43 || $[76] !== t45) {
    t46 = <Stack spacing={1.25}>{t43}{t45}</Stack>;
    $[75] = t43;
    $[76] = t45;
    $[77] = t46;
  } else {
    t46 = $[77];
  }
  let t47;
  if ($[78] !== t37 || $[79] !== t46) {
    t47 = <Box sx={t37}>{t46}</Box>;
    $[78] = t37;
    $[79] = t46;
    $[80] = t47;
  } else {
    t47 = $[80];
  }
  let t48;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = {
      p: {
        xs: 1.5,
        sm: 2.5
      },
      minWidth: 0
    };
    $[81] = t48;
  } else {
    t48 = $[81];
  }
  let t49;
  if ($[82] !== LL) {
    t49 = <Box sx={t48}><HomeLandingHeroPreviewRuntime LL={LL} /></Box>;
    $[82] = LL;
    $[83] = t49;
  } else {
    t49 = $[83];
  }
  let t50;
  if ($[84] !== t47 || $[85] !== t49) {
    t50 = <Box sx={t28}>{t47}{t49}</Box>;
    $[84] = t47;
    $[85] = t49;
    $[86] = t50;
  } else {
    t50 = $[86];
  }
  let t51;
  if ($[87] !== t27 || $[88] !== t50 || $[89] !== t7) {
    t51 = <Box sx={t7}>{t27}{t50}</Box>;
    $[87] = t27;
    $[88] = t50;
    $[89] = t7;
    $[90] = t51;
  } else {
    t51 = $[90];
  }
  return t51;
};